import { createStore } from 'vuex'
import modules_options from './modules_options';


export default createStore({
  state: {
    prefix_barcode_qty: '',
    prefix_barcode_prc: '',
    scale_barcode_length: 6,
    suffix_length: 1,
    pesapal_on: false,
    efris_link: '',
    efris_on: false,

  },
  getters: {
    posData(state){
      return {
        prefix_barcode_qty : state.prefix_barcode_qty,
        prefix_barcode_prc : state.prefix_barcode_prc,
        scale_barcode_length : state.scale_barcode_length,
        suffix_length : state.suffix_length,
        pesapal_on: state.pesapal_on,
        efris_link: state.efris_link,
        efris_on: state.efris_on
      }
    }
  },
  mutations: {
    SET_INITITAL_DATA(state, responseData) {
      state.prefix_barcode_qty = responseData.prefix_barcode_qty;
      state.prefix_barcode_prc = responseData.prefix_barcode_prc;
      state.scale_barcode_length = responseData.scale_barcode_length;
      state.suffix_length = responseData.suffix_length;
      state.pesapal_on = responseData.pesapal_on;
      state.efris_link = responseData.efris_link;
      state.efris_on = responseData.efris_on;
  },
  },
  actions: {
  },
  modules: {
    modules_options
  }
})
